/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Whole_Penguin_NailInputs */

const fr_mild_whole_penguin_nail = /** @type {(inputs: Mild_Whole_Penguin_NailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile - Programmes`)
};

/**

* @param {Mild_Whole_Penguin_NailInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mild_whole_penguin_nail = /** @type {((inputs?: Mild_Whole_Penguin_NailInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Whole_Penguin_NailInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mild_whole_penguin_nail(inputs)
});